import { initializeApp, getApps, getApp } from 'firebase/app'
import { initializeFirestore, connectFirestoreEmulator } from 'firebase/firestore'
import { getStorage, connectStorageEmulator } from 'firebase/storage'
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions'
import {
  initializeAuth,
  connectAuthEmulator,
  indexedDBLocalPersistence,
  browserLocalPersistence,
  inMemoryPersistence,
  getAuth,
} from 'firebase/auth'
import { IS_PRODUCTION, FIREBASE_PROJECT_ID } from '../constants/index'

const firebaseConfig = JSON.parse(
  process.env.REACT_APP_CONFIG ||
    `{"projectId": "${FIREBASE_PROJECT_ID}", "apiKey": "123", "storageBucket": "${FIREBASE_PROJECT_ID}.appspot.com"}`
)

// HMR-safe app init
export const firebaseApp = !getApps().length ? initializeApp(firebaseConfig) : getApp()

const isDev = process.env.NODE_ENV !== 'production'
export const auth =
  (isDev && globalThis.__auth) ||
  initializeAuth(firebaseApp, {
    persistence: [indexedDBLocalPersistence, browserLocalPersistence, inMemoryPersistence],
  })

if (isDev) globalThis.__auth = auth

// Firestore. Auto-detect long polling: if something on the network buffers the
// streamed WebChannel response (seen on the Holmasto office network), the SDK
// switches to long polling right away instead of stalling for 10+ seconds.
// This is the default from firebase 9.22 onwards.
export const db =
  (isDev && globalThis.__db) || initializeFirestore(firebaseApp, { experimentalAutoDetectLongPolling: true })
if (isDev) globalThis.__db = db
// Storage
export const storage = getStorage(firebaseApp)
// Functions
export const functions = getFunctions(firebaseApp, 'europe-west3')

// Secondary instance (for user creation only)
export const secondaryAppInstance = !getApps().find(a => a.name === 'super-admin')
  ? initializeApp(firebaseConfig, 'super-admin')
  : getApp('super-admin')

export const creatingUserAuth = getAuth(secondaryAppInstance)

// Emulators
if (!IS_PRODUCTION) {
  connectFirestoreEmulator(db, 'localhost', 8080)
  connectStorageEmulator(storage, 'localhost', 9199)
  connectFunctionsEmulator(functions, 'localhost', 5001)
  connectAuthEmulator(auth, 'http://localhost:9099')
  connectAuthEmulator(creatingUserAuth, 'http://localhost:9099')
}
